/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteRenewStatus;

(function (QuoteRenewStatus) {
  QuoteRenewStatus["NOT_YET"] = "not_yet";
  QuoteRenewStatus["RENEW_SOON"] = "renew_soon";
  QuoteRenewStatus["RENEWED"] = "renewed";
})(QuoteRenewStatus || (QuoteRenewStatus = {}));